<template>
  <div class="tbf">
    <div class="background--white">	 
      <div
        class="tbf__mobile-background"
        :style="mobileStyle"
      />
      <div class="tbf__cols">
        <div
          v-show="invert"
          class="tbf__col tbf__col--ha-center tbf__col--va-center tbf__col--ta-left"  
        >
          <div class="tbf__content">
            <div
              class="text-element"
            >
              <h2 class="headline-secondary-large">
                <span class="dtva-header__name">
                  <slot />
                </span>
              </h2>
              <p class="text-primary">
                {{ caption }}
              </p>
              <p style="padding-bottom: 20px;">
                <a
                  id="link_"
                  :href="url"
                  class=" button button--outline button--black button--icon icon-arrow-left-2019"
                  data-info="internallink"
                  target="_self"
                  rel=""
                  title="Alt"
                >{{ buttonLabel }}</a>
              </p>
            </div>
          </div>
        </div>
        <div class="tbf__col tbf__col--half tbf__col--image tbf__col--ha-center tbf__col--va-center">		
          <img
            :src="img"
          >
        </div>
        <div
          v-show="!invert"
          class="tbf__col tbf__col--ha-center tbf__col--va-center tbf__col--ta-left"
        >
          <div class="tbf__content">
            <div
              class="text-element"
            >
              <h2 class="headline-secondary-large">
                <span class="dtva-header__name">
                  <slot />
                </span>
              </h2>
              <p class="text-primary">
                {{ caption }}
              </p>
              <p style="padding-bottom: 20px;">
                <a
                  id="link_"
                  :href="url"
                  class=" button button--outline button--black button--icon icon-arrow-left-2019"
                  data-info="internallink"
                  target="_self"
                  rel=""
                  title="Alt"
                >{{ buttonLabel }}</a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <br>
    <br>
    <br>
  </div>
</template>

<script>

export default {
  name: 'Teaser',
  props: {
    name: {
      type: String,
      required: true,
    },
    id: {
      type: String,
      required: true,
    },
    url: {
      type: String,
      required: true,
    },
    img: {
      type: String,
      required: true,
    },
    imgMobile: {
      type: String,
      required: true,
    },
    caption: {
      type: String,
      required: false,
      default: "",
    },
    buttonLabel: {
      type: String,
      required: false,
      default: "",
    },
    invert: {
      type: Boolean,
      required: false,
      default: false
    },
  },
  computed: {
    mobileStyle: function() {
      return "background-image: url('" + this.imgMobile + "');";
    },
  },
};
</script>

<style lang="scss" src="./teaser-banner.scss">
</style>
